import Auth from './Auth';
import User from './User';
import Profile from './Profile';
import Shipment from './Shipment';
import Countries from './Countries';
import ErrorTracking from './ErrorTracking';
import Promocodes from './Promocodes';
import Feedback from './Feedback';
import Search from './Search';
import Banners from './Banners';
import Guest from './Guest';
import Calculator from './Calculator';
import ProfileV2 from './ProfileV2';
import GatewayCategory from './GatewayCategory';
import GatewayAiService from './GatewayAiService';

const agent = {
  Auth,
  User,
  Profile,
  ProfileV2,
  Shipment,
  Search,
  Banners,
  Countries,
  Guest,
  Calculator,
  ErrorTracking,
  Promocodes,
  Feedback,
  Gateway: {
    AiService: GatewayAiService,
    Category: GatewayCategory,
  },
};

export default agent;
